
export default {
  name: 'FaqPageManager',
  // We use the `provide` API to give child components access to a method
  provide() {
    console.log('✅ FaqPageManager: provide() called. This component is ready to receive data.');
    return {
      addFaqData: this.addFaqData,
    };
  },
  data() {
    return {
      // This array will collect all FAQ data from all FaqContainer components
      faqItems: [],
    };
  },
  computed: {
    faqPageSchemaContent() {
      console.log('FaqPageManager: faqPageSchemaContent computed property is running.');
      if (this.faqItems.length === 0) {
        console.log('FaqPageManager: No FAQ data collected yet. Schema will not be rendered.');
        return null; // Don't render if no data is present
      }
      
      console.log(`FaqPageManager: Processing ${this.faqItems.length} items to build schema.`);
      const mainEntity = this.faqItems.map(item => ({
        "@type": "Question",
        "name": item.question,
        "acceptedAnswer": {
          "@type": "Answer",
          "text": item.answerHtml
        }
      }));

      const schema = {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        mainEntity
      };
      
      console.log('FaqPageManager: ✅ Generated schema successfully.');
      return JSON.stringify(schema, null, 2);
    }
  },
  methods: {
    // This method is called by FaqContainer components to send their data
    addFaqData(data) {
      console.log('FaqPageManager: ✅ Received data from a child.');
      // Add the new FAQ data to the main array, preventing duplicates
      data.forEach(newItem => {
        if (!this.faqItems.some(item => item.question === newItem.question)) {
          this.faqItems.push(newItem);
        }
      });
    },
  }
};
